import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";
import { SUPPORTED_LANGUAGES, type SupportedLanguage } from "@/i18n";

export function LanguageSwitcher({ className }: { className?: string }) {
  const { t, i18n } = useTranslation("common");
  const current = (i18n.resolvedLanguage ?? "en") as SupportedLanguage;

  return (
    <div
      role="group"
      aria-label={t("language.label")}
      className={cn("inline-flex rounded-md border p-0.5", className)}
    >
      {SUPPORTED_LANGUAGES.map((lng) => (
        <button
          key={lng}
          type="button"
          lang={lng}
          aria-pressed={current === lng}
          title={t(`language.${lng}`)}
          onClick={() => void i18n.changeLanguage(lng)}
          className={cn(
            "rounded px-2 py-0.5 text-xs font-medium uppercase transition-colors",
            current === lng
              ? "bg-accent text-accent-foreground"
              : "text-muted-foreground hover:text-foreground"
          )}
        >
          {lng}
        </button>
      ))}
    </div>
  );
}
